// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"Tooltip_tooltipContainer__5J1wo","tooltipTrigger":"Tooltip_tooltipTrigger__hZrkL","tooltipText":"Tooltip_tooltipText__QFSDA"};